import '../index.css'
import * as React from 'react'
import { useContext } from 'react'
import { Button, Table, Tag } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import { PlusOutlined } from '@ant-design/icons'
import { InfoCxt } from '../../../App'
import { PaddingBox, PageSubtitle, PageTitle, TabHeader, TableBox } from '../../../components/Wrapper'

export const getColor = (name: string) => {
  const _name = name.toLowerCase()
  if (['blue', 'purple', 'green'].includes(_name)) return _name
  return '#BFBFBF'
}

export const getStatusName = (name: string) => {
  const _name = name.toLowerCase()
  if (['purple', 'green'].includes(_name)) return 'Completed'
  if (_name === 'blue') return 'In Progress'
  return 'Uncompleted'
}

export interface GoalType {
  id: string
  completionBonus: number
  completionCount: number
  completionType: string
  description: string
  eachCount: number
  externalLink: string
  goalCategory: string
  goalImage: string
  goalName: string
  goalTitle: string
  goalType: string
  trackingType: string
  whyItIsImportant: string
}

export interface GoalExtraType {
  assignee: string
  checkList: string[]
  startTime: string
  statusColor: string
}

export type GoalDataType = GoalType & GoalExtraType

const columns: ColumnsType<GoalDataType> = [
  { title: 'Start Date', dataIndex: 'startTime' },
  { title: 'Duration', dataIndex: 'completionType' },
  { title: 'Type', dataIndex: 'goalType' },
  { title: 'Category', dataIndex: 'goalCategory' },
  { title: 'Title', dataIndex: 'goalTitle' },
  {
    title: 'Status',
    dataIndex: 'statusColor',
    render: (_, { statusColor }) => <Tag color={getColor(statusColor)}>{getStatusName(statusColor)}</Tag>,
  },
  { title: 'Assignee', dataIndex: 'assignee' },
  { title: 'Action', width: '116px', render: () => null },
]

/* -------------------------------- react fc -------------------------------- */

const Goals: React.FC = () => {
  const { showComingSoon } = useContext(InfoCxt)

  return (
    <>
      <TabHeader border>
        <PageTitle text='Goals' />
        <Button type='primary' ghost icon={<PlusOutlined />} onClick={showComingSoon}>
          Add
        </Button>
      </TabHeader>
      <PaddingBox>
        <PageSubtitle text='Assigned Goals' />
        <TableBox>
          <Table columns={columns} dataSource={[]} rowKey={(record) => record.id} pagination={false} />
        </TableBox>
      </PaddingBox>
    </>
  )
}

export default Goals
